import {useQuery} from 'react-query'

async function getAcceptLectures()
{
    const response = await fetch(`${process.env.REACT_APP_API_KEY}api/v1/teacher/lectures/status/accept-lectures`
    )
    return response.json()
}

export const useMyAcceptLectures = ()=>
{
    return useQuery('get-accept-lectures',()=>getAcceptLectures())
}